<template>
  <div class="wl-tasting mt-3" v-if="template">
    <div class="wl-data-table">
      <div class="row wl-data-table-header">
        <div class="col">Description</div>
        <div class="col-2 col-xl-2">Bottle Size</div>
        <div class="col-2 col-xl-2">Invoice Price</div>
        <div class="col-2 col-xl-2">Selling Price</div>
      </div>
      <draggable v-model="template" handle=".group-handle" @end="update_order">
        <div class="wl-group" v-for="(group, index) in template" :key="index">
          <div class="row">
            <div class="col">
              <h5
                class="wl-group-header group-handle"
                :class="{ 'group-handle': editable }"
                v-if="group.name"
              >
                <svg
                  class="bi"
                  fill="currentColor"
                  width="17px"
                  height="17px"
                  v-if="editable"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                  />
                </svg>
                {{ group.name }}
              </h5>
            </div>
          </div>
          <draggable v-model="group.items" handle=".handle" @end="update_order">
            <div
              class="wl-data-table-row"
              v-for="item in group.items"
              :key="item.product._id"
              :class="{ 'opacity-1': item.hide }"
            >
              <div class="wl-vertical-grab-handle handle" v-if="editable">
                <svg
                  class="bi mt-1 mb-2"
                  fill="currentColor"
                  width="18px"
                  height="18px"
                >
                  <use
                    xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                  /></svg
                ><br />
                <b-link
                  class=""
                  @click="
                    item.hide = !item.hide;
                    hide_item(item.item_code, item.hide);
                  "
                >
                  <svg
                    class="bi mb-2"
                    fill="currentColor"
                    width="18px"
                    height="18px"
                  >
                    <use
                      xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#eye-slash"
                    />
                  </svg> </b-link
                ><br />
                <b-link
                  @click="$emit('remove-item', { item_code: item.item_code })"
                  ><svg
                    class="bi mb-2"
                    fill="currentColor"
                    width="18px"
                    height="18px"
                  >
                    <use
                      xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x-square"
                    />
                  </svg>
                </b-link>
              </div>
              <div class="row mb-1" :class="{ 'has-grab-bar': editable }">
                <div class="col">
                  <a :href="item.product._source.Permalink" target="_blank">{{
                    item.product._source.ItemDescription[0]
                  }}</a
                  ><br />
                  <small>LWIN: {{ item.item_code.substr(0, 7) }}</small>
                </div>
                <div class="col-2 col-xl-2">
                  {{ item.product._source.BottleSize }}
                  <br />
                  <small v-if="!hideGlass"
                    >125ml: {{ item.price_125ml | currency }}
                  </small>
                </div>
                <div class="col-2 col-xl-2">
                  {{ item.actual_price | currency }}
                  <br />
                  <small v-if="!hideGlass"
                    >175ml: {{ item.price_175ml | currency }}
                  </small>
                </div>
                <div class="col-2 col-xl-2">
                  <span v-if="item.selling_price">{{
                    item.selling_price | currency
                  }}</span>
                  <span v-else-if="editable"
                    ><b-link :to="'/edit/price-list/' + slug"
                      >Not Set</b-link
                    ></span
                  ><span v-else>Not Set</span><br />
                  <small v-if="!hideGlass"
                    >250ml: {{ item.price_250ml | currency }}
                  </small>
                </div>
              </div>
              <div class="row" :class="{ 'has-grab-bar': editable }">
                <div class="col-12">
                  <b-form-textarea
                    :readonly="viewMode"
                    placeholder="Notes..."
                    v-model="item.notes"
                    @change="update_notes(item.item_code, item.notes)"
                  ></b-form-textarea>
                  <!-- <div style="white-space: pre-line" v-else>
                    {{ item.notes }}
                  </div> -->
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array,
    },
    slug: {
      type: String,
    },
    presentationMode: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    hideGlass: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    margin: () => (item) => {
      return (
        (item.actual_price ?? item.list_price) -
        (item.cost_price / (item.actual_price ?? item.list_price)) * 100
      );
    },
  },
  mounted() {
    this.data_incoming = true;
    this.template = JSON.parse(JSON.stringify(this.value));
  },
  methods: {
    update_notes(item_code, notes) {
      this.$emit("update-item", {
        item_code,
        notes,
      });
    },
    hide_item(item_code, hide) {
      this.$emit("hide-item", {
        template: "TASTING",
        data: {
          item_code,
          hide,
        },
      });
    },
    update_order() {
      this.$emit("update-order", {
        template: "TASTING",
        data: {
          groups: this.template,
        },
      });
    },
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        this.template = JSON.parse(JSON.stringify(val));
      },
    },
    template: {
      deep: true,
      handler(val) {
        if (this.data_incoming) {
          this.data_incoming = false;
          return;
        }

        this.$emit("change", val);
      },
    },
  },
  data() {
    return {
      template: false,
      data_incoming: false,
    };
  },
};
</script>